import { Divider as MuiDivider } from '@mui/material';
import { styled } from '@mui/material/styles';

const Divider = styled(MuiDivider)(({ theme }) => ({
  background: theme.custom.themeColors.grayScale[20],
}));

export default Divider;
